export default "/_next/static/chunks/fonts/Source Sans Pro Regular-7a9975d8c02d6933c47df31af5854fb2.otf";